import { ValidatorFn, Validators } from '@angular/forms';

export function passwordValidator(): ValidatorFn {
  return Validators.pattern(/(?=^.{8,}$)(?=.*\d)(?=.*[\W]+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/);
}
